export const requestStatuses = {
  INIT: 'init',
  PENDING: 'pending',
  SUCCESS: 'success',
  FAILED: 'failed',
  LOADING: 'loading',
};